import { apiClient } from "./authService";

export interface FavoriteVideo {
  _id: string;
  video: { _id: string; title: string; thumbnailUrl?: string } | string;
  createdAt: string;
}

const favoritesService = {
  /** GET /favorites/videos — returns user's favorited video records */
  getVideoFavorites: async (): Promise<FavoriteVideo[]> => {
    const { data } = await apiClient.get<{ success: boolean; data: FavoriteVideo[] }>(
      "/favorites/videos"
    );
    return data.data;
  },

  /** POST /favorites/toggle — toggle a video favorite, returns { isFavorite: boolean } */
  toggleVideo: async (videoId: string): Promise<boolean> => {
    const { data } = await apiClient.post<{
      success: boolean;
      data: { isFavorite: boolean };
    }>("/favorites/toggle", {
      itemType: "video",
      videoId,
    });
    return data.data.isFavorite;
  },
};

export default favoritesService;
